import classNames from "classnames"
import React from "react"

import CalendarIcon from "@components/elements/V2/Icons/CalendarIcon"
import DeliveryIcon from "@components/elements/V2/Icons/DeliveryIcon"
import StarCircleIcon from "@components/elements/V2/Icons/StarCircleIcon"
import IconBadge from "@components/experiments/IconBadge"

type Props = {
  tags?: Storyblok.ProductTag[]
  className?: string
}

const TagDisplay = ({ tags, className }: Props) => {
  return (
    <div
      className={classNames(className, "flex flex-wrap gap-10 py-12 md:py-8")}
    >
      {tags && tags.length > 0 ? (
        tags.map((tag) => (
          <IconBadge
            key={`${tag.text}-${tag.icon.filename}`}
            icon={tag.icon.filename}
            text={tag.text}
            variant={tag.variant}
          />
        ))
      ) : (
        <>
          <IconBadge
            icon={<DeliveryIcon />}
            text="FREE shipping"
            variant="light"
            highlightedText="FREE"
          />
          <IconBadge
            icon={<CalendarIcon />}
            text="1 year warranty"
            variant="light"
            highlightedText="1 year"
          />
          <IconBadge
            icon={<StarCircleIcon />}
            text="30 day money-back guarantee"
            variant="light"
            highlightedText="30 day"
          />
        </>
      )}
    </div>
  )
}

export default TagDisplay
